import React from 'react';
import {AssistantMessageItem} from '../../api/types';
import MarkdownMessage from '../MarkdownMessage';

const AssistantMessageItemView: React.FC<{item: AssistantMessageItem}> = ({
    item
}) => (
    <div className="mb-2 assistant-message-item">
        <MarkdownMessage
            text={item.text}
            isStreaming={item.status === 'in_progress'}
        />
        {item.status === 'in_progress' && <span className="text-muted">▍</span>}
    </div>
);

export default AssistantMessageItemView;
